import React from "react";

import { Stage } from "react-konva";

import { useScrubbing } from "../../hooks/useScrubbing";
import { TimelineRuler } from "./TimelineRuler";

type Props = {
  width: number;
  height: number;
  pixelsPerSecond: number;
  scrollLeft: number;
  durationSeconds: number;
  maxScroll: number;
  setScrollLeft: (fn: (prev: number) => number) => void;
  onScrub: (t: number | null) => void;
};

const arePropsEqual = (prev: Props, next: Props): boolean => {
  if (prev.width !== next.width || prev.height !== next.height) return false;
  if (prev.pixelsPerSecond !== next.pixelsPerSecond) return false;
  if (prev.scrollLeft !== next.scrollLeft) return false;
  return (
    prev.durationSeconds === next.durationSeconds &&
    prev.maxScroll === next.maxScroll &&
    prev.setScrollLeft === next.setScrollLeft &&
    prev.onScrub === next.onScrub
  );
};

export const RulerCanvas: React.FC<Props> = React.memo(
  ({ width, height, pixelsPerSecond, scrollLeft, durationSeconds, maxScroll, setScrollLeft, onScrub }) => {
    const { stageRef, onPointerDown } = useScrubbing({
      pixelsPerSecond,
      scrollLeft,
      durationSeconds,
      width,
      maxScroll,
      setScrollLeft,
      onScrub,
    });

    if (!(width > 0) || !(height > 0)) return null;

    return (
      <div style={{ position: "relative", width, height }}>
        {/* Retain the shared scrub gesture; the SVG above it owns all visuals. */}
        <Stage height={height} ref={stageRef} width={width} onPointerDown={onPointerDown} />
        <TimelineRuler
          durationSeconds={durationSeconds}
          pixelsPerSecond={pixelsPerSecond}
          scrollLeft={scrollLeft}
          width={width}
        />
      </div>
    );
  },
  arePropsEqual,
);

RulerCanvas.displayName = "RulerCanvas";
